import { render } from "./EmployeePayrollOverview.vue?vue&type=template&id=7691feb5"
import script from "./EmployeePayrollOverview.vue?vue&type=script&lang=js"
export * from "./EmployeePayrollOverview.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__